import axios from "axios"
import baseURL from "../configs/api"

export const post_VehicleReplace = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}vehicleReplacement?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_VehicleReplace = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}vehicleReplacement?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getVehicleReplaceReportByReservationId = (primaryKey: number, tenantId: string) => {
    return getFetch(`vehicleReplacement/GetVehicleReplacementReportByReservationId/${primaryKey}`, tenantId);
}

export const getVehicleReplacementByReservationId = (primaryKey: number, tenantId: string) => {
    return getFetch(`vehicleReplacement/GetVehicleReplacementsByReservationId/${primaryKey}`, tenantId);
}

export const getVehicleReplaceId = (primaryKey: string, tenantId: string) => {
    return getFetch(`vehicleReplacement/GetVehicleReplacement/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}